import {Input, Typography} from 'antd';
import CardItem from './CardItem';
import {useState, useCallback} from 'react';
import debounce from 'lodash/debounce';
const {Text} = Typography;

const ShippingAddress = ({
  shippingAddress,
  updateAddress,
  updateAllAddressData,
  onPhoneNumberUpdate,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchAddressDetails = async (pincode) => {
    if (pincode.length === 6) {
      setIsLoading(true);
      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        const data = await response.json();

        console.log("PinCodeData",data )
        
        if (data[0].Status === "Success" && data[0].PostOffice?.length > 0) {
          const addressInfo = data[0].PostOffice[0];
          updateAllAddressData({
            city: addressInfo.District,
            province: addressInfo.State,
            country: addressInfo.Country,
            zip: pincode
          })
        }
      } catch (error) {
        console.error('Error fetching pincode details:', error);
        updateAddress('zip', pincode);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchAddress = useCallback(
    debounce((pincode) => {
      fetchAddressDetails(pincode);
    }, 500),
    [shippingAddress]
  );

  const handlePinCodeChange = (e) => {
    const pincode = e.target.value;
    updateAddress('zip', pincode);
    if (pincode) {
      debouncedFetchAddress(pincode);
    }
  };

  return (
    <CardItem>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Shipping Address
        </Text>
      </div>
      <Input
        placeholder="Enter First Name"
        value={shippingAddress?.first_name}
        onChange={e => {
          updateAddress('first_name', e.target.value);
        }}
      />
      <Input
        placeholder="Enter Last Name"
        value={shippingAddress?.last_name}
        onChange={e => {
          updateAddress('last_name', e.target.value);
        }}
      />
      <Input
        placeholder="Enter Phone Number"
        value={shippingAddress?.phone}
        onChange={e => {
          updateAddress('phone', e.target.value);
        }}
        onBlur={e => onPhoneNumberUpdate && onPhoneNumberUpdate(e.target.value)}
        onPressEnter={e =>
          onPhoneNumberUpdate && onPhoneNumberUpdate(e.target.value)
        }
      />
      <Input
        placeholder="Enter Address"
        value={shippingAddress?.address1}
        onChange={e => {
          updateAddress('address1', e.target.value);
        }}
      />
      <Input
        placeholder="Enter City"
        value={shippingAddress?.city}
        disabled={isLoading}
        onChange={e => {
          updateAddress('city', e.target.value);
        }}
      />
      <Input
        placeholder="Enter State"
        value={shippingAddress?.province}
        disabled={isLoading}
        onChange={e => {
          updateAddress('province', e.target.value);
        }}
      />
      <Input
        placeholder="Enter Pin Code"
        value={shippingAddress?.zip}
        onChange={handlePinCodeChange}
      />
      <Input
        placeholder="Enter Country"
        value={shippingAddress?.country}
        disabled={isLoading}
        onChange={e => {
          updateAddress('country', e.target.value);
        }}
      />
    </CardItem>
  );
};

export default ShippingAddress;
